"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.CHAUFFEUR_ENDPOINT = {
    getChauffeurDetails: '/user-company/backoffice/users/{{chauffeurUuid}}/chauffeurs',
    putChauffeurStatus: '/user-company/backoffice/users/{{chauffeurUuid}}/chauffeurs/status',
    putChauffeurCallsign: '/user-company/backoffice/users/{{chauffeurUuid}}/chauffeurs/callsign',
    putVehicleToChauffeur: '/user-company/backoffice/users/{{chauffeurUuid}}/chauffeurs/vehicles',
    deleteChauffeurDocumentation: '/user-company/backoffice/users/{{chauffeurUuid}}/chauffeurs/documentation/{{documentUuid}}',
    patchChauffeurDocumentation: '/backoffice/user-company/{{version}}/users/{{chauffeurUuid}}/chauffeurs/documentation/{{documentUuid}}`',
};
